import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const CircleLogoutIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9C2 5.15228 5.15228 2 9 2H11C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0H9C4.04772 0 0 4.04772 0 9V11C0 15.9523 4.04772 20 9 20H11C11.5523 20 12 19.5523 12 19C12 18.4477 11.5523 18 11 18H9C5.15228 18 2 14.8477 2 11V9ZM15.3643 5.22807C15.7906 4.87698 16.4208 4.93797 16.7719 5.36429L19.5475 8.73461C20.1822 9.41216 20.1842 10.4792 19.5533 11.1591L16.7809 14.6247C16.4359 15.056 15.8066 15.1259 15.3753 14.7809C14.944 14.4359 14.8741 13.8066 15.2191 13.3753L17.1194 11H9C8.44771 11 8 10.5523 8 10C8 9.44771 8.44771 9 9 9H17.1751L15.2281 6.63571C14.877 6.20938 14.938 5.57916 15.3643 5.22807Z",
    fill: color
  }));
};
export default CircleLogoutIcon;